module.exports = __webpack_public_path__ + "static/img/icon.428f467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = 806
// module chunks = 2